import axios from 'axios';
import config from './config';


const axiosInstance = axios.create({
    baseURL: config.api.baseUrl,
});

// Add a request interceptor to include the token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 Unauthorized
export const setupAxiosInterceptors = (logout: () => void) => {
    axiosInstance.interceptors.response.use(
        (response) => response, // Return the response if successful
        async (error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);

                if (error.response.status === 401) {
                    logout(); // Call the provided logout function
                    window.location.href = '/login'; // Redirect to login page
                }
            }
            return Promise.reject(error);
        }
    );
};


export default axiosInstance;